/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Receipt_Not_FoundInputs */

const vi_error_payment_receipt_not_found = /** @type {(inputs: Error_Payment_Receipt_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy phiếu thu này của khách, có thể vừa bị xoá. Tải lại trang để xem sổ công nợ mới nhất.`)
};

/**

* @param {Error_Payment_Receipt_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_receipt_not_found = /** @type {((inputs?: Error_Payment_Receipt_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Receipt_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_receipt_not_found(inputs)
});